import type { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

type Props = {
    url: string;
    isAllowed: boolean;
    children?: ReactNode;
};

function ProtectedRouter({ url, isAllowed, children }: Props) {
    if (!isAllowed) {
        return <Navigate to={url} />;
    }

    return children ? children : <Outlet />;
}

export default ProtectedRouter;